
$.fn.extend({
    moveTabs(positionInput) {
        const tabsRows = [];
        const element = this;

        element.api({
            method: 'PUT',
            beforeSend(settings) {
                settings.data = {
                    fillingPatternTabs: tabsRows,
                    _csrf_token: element.data('csrf-token'),
                };

                return settings;
            },
            onSuccess() {
                window.location.reload();
            },
        });

        positionInput.on('input', (event) => {
            const input = $(event.currentTarget);
            const tabId = input.data('id');
            const row = tabsRows.find(({ id }) => id === tabId);

            if (!row) {
                tabsRows.push({
                    id: tabId,
                    position: input.val(),
                });
            } else {
                row.position = input.val();
            }
        });
    },
});

$(document).ready(() => {
    $('.app-update-filling-pattern-tab-positions').moveTabs($('.app-filling-patter-tab-position'));
});
